// extracted by mini-css-extract-plugin
module.exports = {"chart-axis":"Axis_chart-axis__3zjyv","chart-axis-ticks":"Axis_chart-axis-ticks__3xHvP"};